import { z } from 'zod'

/** Token */
export const tokenSchema = z.object({
  /** Token */
  access_token: z.string(),
  /** 使用者帳號 */
  accountNo: z.string(),
  /** Token 期限 */
  expires_in: z.number(),
  refresh_token: z.string(),
  scope: z.string(),
  token_type: z.literal('bearer')
})

export interface Token extends z.infer<typeof tokenSchema> {}
